// extracted by mini-css-extract-plugin
module.exports = {"content":"Modal_diet_content__2Nuuo","buttons":"Modal_diet_buttons__YFIBh"};